import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import init100 from '../assets/init100.png';

// Custom link component that scrolls to top on click
const ScrollToTopLink = ({ to, children, sx }) => {
  const navigate = useNavigate();
  
  const handleClick = (e) => {
    e.preventDefault();
    navigate(to);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <Link 
      href={to}
      onClick={handleClick}
      sx={sx}
    >
      {children}
    </Link>
  );
};

const Footer = () => {
  
  const pages = [
    { name: 'Home', path: '/' },
    { name: 'Features', path: '/features' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const products = [
    { name: 'Solvenda Core', path: '/features' },
    { name: 'SolvendaRadius', path: '/features' },
    { name: 'Fiscalization', path: '/features' },
    { name: 'Solvenda OLT', path: '/features' },
    { name: 'Solvenda DNS', path: '/features' },
    { name: 'Logs History', path: '/features' },
    { name: 'SolvendaConnect', path: '/connect' },
  ];

  const linkSx = {
    color: '#fff',
    textDecoration: 'none',
    opacity: 0.7,
    transition: 'opacity 0.2s',
    '&:hover': { opacity: 1 },
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#0A0D13',
        color: '#ffffff',
        py: 6,
        mt: 'auto',
        borderTop: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box 
                component="img" 
                src={init100}
                alt="SVN Logo"
                sx={{ height: 40, mr: 1 }}
              />
              <Typography variant="h6" component="div" sx={{ fontWeight: 800 }}>
                SOLVENDA
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 3, opacity: 0.7 }}>
              The complete management solution for ISPs.
            </Typography>
            <Link href="https://connect.solvenda.org" target="_blank" rel="noopener noreferrer" sx={{ ...linkSx, fontWeight: 700, opacity: 0.9, color: '#34C77B' }}>
              Pay a bill →
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" component="h3" sx={{ mb: 2 }}>
              Products
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              {products.map((p, i) => (
                <Box component="li" key={i} sx={{ mb: 1.5 }}>
                  <ScrollToTopLink to={p.path} sx={linkSx}>
                    {p.name}
                  </ScrollToTopLink>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" component="h3" sx={{ mb: 2 }}>
              Pages
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              {pages.map((page, i) => (
                <Box component="li" key={i} sx={{ mb: 1.5 }}>
                  <ScrollToTopLink to={page.path} sx={linkSx}>
                    {page.name}
                  </ScrollToTopLink>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" component="h3" sx={{ mb: 2 }}>
              Contact
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              <Box component="li" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                <EmailIcon sx={{ mr: 1, opacity: 0.7 }} />
                <Link 
                  href="mailto:info@solvenda.org"
                  sx={{ 
                    color: '#fff',
                    textDecoration: 'none',
                    opacity: 0.7,
                    transition: 'opacity 0.2s',
                    '&:hover': {
                      opacity: 1,
                    },
                  }}
                >
                  info@solvenda.org
                </Link> 
              </Box>
              <Box component="li" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                <PhoneIcon sx={{ mr: 1, opacity: 0.7 }} />
                <Typography sx={{ opacity: 0.7 }}>
                  +355 69 654 6099
                </Typography>
              </Box>
              <Box component="li" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                <PhoneIcon sx={{ mr: 1, opacity: 0.7 }} />
                <Typography sx={{ opacity: 0.7 }}>
                  +355 69 209 8563
                </Typography>
              </Box>
              <Box component="li" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                <LocationOnIcon sx={{ mr: 1, opacity: 0.7 }} />
                <Typography sx={{ opacity: 0.7 }}>
                  Tirane, Albania
                </Typography>
              </Box>
              <Box component="li" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                <LocationOnIcon sx={{ mr: 1, opacity: 0.7 }} />
                <Typography sx={{ opacity: 0.7 }}>
                  Lezhe, Albania
                </Typography>
              </Box>
              {/* <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                <IconButton 
                  component="a"
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ 
                    color: '#fff',
                    p: 1,
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                    }
                  }}
                >
                  <FacebookIcon fontSize="small" />
                </IconButton>
                <IconButton 
                  component="a"
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ 
                    color: '#fff',
                    p: 1,
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                    }
                  }}
                >
                  <TwitterIcon fontSize="small" />
                </IconButton>
                <IconButton 
                  component="a"
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ 
                    color: '#fff',
                    p: 1,
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                    }
                  }}
                >
                  <LinkedInIcon fontSize="small" />
                </IconButton>
              </Stack> */}
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'center', sm: 'flex-start' } }}>
          <Typography variant="body2" sx={{ opacity: 0.7, mb: { xs: 2, sm: 0 } }}>
            © {new Date().getFullYear()} SOLVENDA. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <ScrollToTopLink 
              to="/privacy-policy"
              sx={{ 
                color: '#fff',
                textDecoration: 'none',
                opacity: 0.7,
                transition: 'opacity 0.2s',
                '&:hover': {
                  opacity: 1,
                },
              }}
            >
              Privacy Policy
            </ScrollToTopLink>
            <ScrollToTopLink 
              to="/terms-of-service"
              sx={{ 
                color: '#fff',
                textDecoration: 'none',
                opacity: 0.7,
                transition: 'opacity 0.2s',
                '&:hover': {
                  opacity: 1,
                },
              }}
            >
              Terms of Service
            </ScrollToTopLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 